import { FormField } from "../form-utils/FormField";
import { UseFormReturn } from "react-hook-form";
import { FormData } from "../form-utils/formValidation";

interface FormFieldsProps {
  form: UseFormReturn<FormData>;
}

export const CompanyFields = ({ form }: FormFieldsProps) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <FormField
      form={form}
      name="companyName"
      label="Company Name"
      placeholder="Acme Inc."
      required
    />
    <FormField
      form={form}
      name="teamSize"
      label="Team Size"
      type="select"
      options={[
        { value: "1-10", label: "1-10 employees" },
        { value: "11-50", label: "11-50 employees" },
        { value: "51-200", label: "51-200 employees" },
        { value: "201-1000", label: "201-1000 employees" },
        { value: "1000+", label: "1000+ employees" },
      ]}
      required
    />
  </div>
);

export const ContactFields = ({ form }: FormFieldsProps) => (
  <div className="space-y-4">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <FormField
        form={form}
        name="contactName"
        label="Contact Name"
        placeholder="John Doe"
        required
      />
      <FormField
        form={form}
        name="role"
        label="Role"
        placeholder="IT Director"
        required
      />
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <FormField
        form={form}
        name="email"
        label="Email"
        type="email"
        placeholder="john@company.com"
        required
      />
      <FormField
        form={form}
        name="phone"
        label="Phone"
        type="tel"
        placeholder="+1 (555) 000-0000"
        required
      />
    </div>
  </div>
);

export const SystemFields = ({ form }: FormFieldsProps) => (
  <div className="space-y-4">
    <FormField
      form={form}
      name="currentSystems"
      label="Current Systems"
      type="textarea"
      placeholder="Please list your current healthcare systems (EHR, EMR, etc.)"
      required
    />
    <FormField
      form={form}
      name="integrationNeeds"
      label="Integration Needs"
      type="textarea"
      placeholder="Describe your integration requirements and goals"
      required
    />
  </div>
);

export const SchedulingFields = ({ form }: FormFieldsProps) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <FormField
      form={form}
      name="preferredDate"
      label="Preferred Consultation Date"
      type="date"
      required
    />
    <FormField
      form={form}
      name="budgetRange"
      label="Budget Range"
      type="select"
      options={[
        { value: "<25k", label: "Less than $25,000" },
        { value: "25k-50k", label: "$25,000 - $50,000" },
        { value: "50k-100k", label: "$50,000 - $100,000" },
        { value: "100k-250k", label: "$100,000 - $250,000" },
        { value: "250k+", label: "$250,000+" },
      ]}
      required
    />
  </div>
);